var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135.528 135.528",
    style: {
      enableBackground: "new 0 0 135.528 135.528"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.5321,
    y1: 20.5316,
    x2: 113.9435,
    y2: 113.943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6EC7DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30AFCC"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 67.764,
    cy: 67.764,
    r: 67.764
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF99A"
    },
    cx: 67.764,
    cy: 67.764,
    r: 32.624
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD800"
    },
    d: "M117.047,67.764c0-3.402-8.175-5.648-8.727-8.343c-0.551-2.695,6.101-7.893,4.854-10.84 c-1.247-2.949-9.594-1.76-11.083-3.963c-1.488-2.202,2.75-9.473,0.521-11.703c-2.23-2.229-9.5,2.008-11.703,0.521 c-2.203-1.488-1.015-9.836-3.963-11.082c-2.948-1.246-8.145,5.405-10.84,4.854c-2.695-0.552-4.941-8.726-8.343-8.726 s-5.648,8.174-8.343,8.726c-2.695,0.551-7.892-6.1-10.841-4.854c-2.948,1.247-1.76,9.595-3.962,11.082 c-2.202,1.487-9.473-2.75-11.702-0.521c-2.23,2.23,2.008,9.501,0.521,11.703c-1.488,2.203-9.835,1.014-11.082,3.963 c-1.247,2.948,5.405,8.145,4.854,10.84c-0.552,2.694-8.727,4.94-8.727,8.343c0,3.402,8.175,5.647,8.727,8.344 c0.551,2.694-6.101,7.892-4.854,10.84c1.247,2.948,9.594,1.76,11.082,3.962c1.488,2.203-2.75,9.474-0.521,11.703 c2.229,2.229,9.5-2.009,11.702-0.521c2.203,1.488,1.015,9.836,3.962,11.083c2.948,1.247,8.146-5.405,10.841-4.854 c2.695,0.552,4.941,8.726,8.343,8.726s5.648-8.175,8.343-8.726c2.695-0.552,7.892,6.101,10.84,4.854 c2.948-1.247,1.76-9.595,3.963-11.083c2.203-1.487,9.473,2.751,11.703,0.521c2.229-2.229-2.009-9.5-0.521-11.703 c1.488-2.202,9.836-1.014,11.083-3.962c1.247-2.948-5.405-8.146-4.854-10.84C108.872,73.411,117.047,71.166,117.047,67.764z  M67.764,104.758c-20.431,0-36.994-16.563-36.994-36.994c0-20.432,16.563-36.994,36.994-36.994 c20.431,0,36.994,16.562,36.994,36.994C104.758,88.195,88.195,104.758,67.764,104.758z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.ca17b392538346f69c892936c37efd7a.svg";
export { ForwardRef as ReactComponent };